import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import LogsVM from './LogsVM';
import { observer } from 'mobx-react';
import { EnumHelper } from "@singularsystems/neo-core";
import { LogLevel } from "../../Models/Logging/LogCriteria";
import LogLookup from "../../Models/Logging/LogLookup";

class LogsParams {
    // TODO: Add parameters here in the form: public paramName = { isQuery?: boolean, required?: boolean };
}

@observer
export default class LogsView extends Views.ViewBase<LogsVM, LogsParams> {
   public static params = new LogsParams();

    constructor(props: unknown) {
        super("Logs", LogsVM, props);
    }

    protected viewParamsUpdated() {

    }

    public render() {
        const viewModel = this.viewModel;

        return (
            <div>
			    <Neo.Card title="Criteria">
                    <Neo.FormGroup bind={viewModel.criteria.meta.fromDate} dateProps={{ formatString: "dd MMM yyyy HH:mm"}} />
                    <Neo.FormGroup bind={viewModel.criteria.meta.level} select={{ items: EnumHelper.asList(LogLevel)}} />
                </Neo.Card>

                <Neo.Card title="Logs">
                    <Neo.Pager pageManager={viewModel.pageManager}>
                        <NeoGrid.Grid<LogLookup>>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.timeStamp} dateProps={{ formatString: "dd MMM yy HH:mm:ss"}} />
                                    <NeoGrid.Column display={meta.level} />
                                    <NeoGrid.Column display={meta.message} />
                                    <NeoGrid.Column display={meta.exception} cellClassName="text-code" />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Pager>
                </Neo.Card>
            </div>
        );
    }
}